module.exports = __webpack_public_path__ + "93e6f6cfad630ba3d4eec7844fe8c1c3.jpg";